'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PostfixStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  disabled: _propTypes2.default.bool,
  /**
   * Full-width TextField doesn't have borders
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * If textfield is dense it has smaller paddings
   */
  dense: _propTypes2.default.bool,
  /**
   * If bordered = false, TextField will have only bottom border
   */
  bordered: _propTypes2.default.bool,
  colorScheme: _propTypes2.default.oneOf(['neutral', 'error', 'success']),
  /**
   * Define component theme config
   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
   * for more information
   */
  theme: _propTypes2.default.object
};

var defaultProps = {
  disabled: false,
  fullWidth: false,
  dense: false,
  bordered: false,
  colorScheme: 'neutral'
};

/** PROP RECEIVERS */
var styleProps = function styleProps(_ref) {
  var disabled = _ref.disabled,
      focus = _ref.focus,
      colorScheme = _ref.colorScheme,
      themeFromProvider = _ref.theme,
      bordered = _ref.bordered;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var TextFieldStyleKey = bordered ? 'bordered' : 'underlined';
  var colorSource = theme.reactackle.components.textfield.postfix.state[TextFieldStyleKey];

  var neutralStyles = colorScheme === 'neutral' && (0, _styledComponents.css)(['background-color:', ';color:', ';', ''], colorSource.backgroundColor, colorSource.fontColor, focus && '\n        outline: none;\n        background-color: ' + colorSource.focus.backgroundColor + ';\n        color: ' + colorSource.focus.fontColor + ';\n      ');

  var stateStyles = colorScheme !== 'neutral' && (0, _styledComponents.css)(['&,&:hover,&:focus{background-color:', ';outline:none;color:', ';}'], colorSource[colorScheme].backgroundColor, colorSource[colorScheme].fontColor);

  var disabledStyles = '\n    &,\n    &:hover,\n    &:focus {\n      background-color: ' + colorSource.disabled.backgroundColor + ';\n      outline: none;\n      cursor: default;\n      user-select: none;\n      color: ' + colorSource.disabled.fontColor + ';\n    }\n  ';

  var styles = null;
  if (disabled) styles = disabledStyles;else if (colorScheme === 'neutral') styles = neutralStyles;else styles = stateStyles;

  return styles;
};

var sizeProps = function sizeProps(_ref2) {
  var dense = _ref2.dense,
      fullWidth = _ref2.fullWidth,
      themeFromProvider = _ref2.theme,
      bordered = _ref2.bordered;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider),
      styleKey = bordered ? 'bordered' : 'underlined',
      path = theme.reactackle.components.textfield.postfix.size,
      textfieldPath = theme.reactackle.components.textfield.textfield.size;

  var source = null;
  var heightSource = null;
  if (dense && !fullWidth) {
    source = path.dense;
    heightSource = textfieldPath.dense;
  } else if (dense && fullWidth) {
    source = path.denseFullWidth;
    heightSource = textfieldPath.denseFullWidth;
  } else if (!dense && fullWidth) {
    source = path.fullWidth;
    heightSource = textfieldPath.fullWidth;
  } else {
    source = path;
    heightSource = textfieldPath;
  }

  var _source = source,
      postfixEdgeSpacing = _source.postfixEdgeSpacing;
  var _heightSource = heightSource,
      paddingY = _heightSource.paddingY,
      lineHeight = _heightSource.lineHeight;


  var minHeight = 'calc(' + (0, _reactackleCore.getValueString)(paddingY) + ' * 2 + ' + lineHeight + 'em)';

  return (0, _styledComponents.css)(['padding-right:', ';max-height:', ';'], (0, _reactackleCore.getValueString)(postfixEdgeSpacing[styleKey]), minHeight);
};

/** STYLES */
var PostfixStyled = exports.PostfixStyled = _styledComponents2.default.label.withConfig({
  displayName: 'PostfixStyled'
})(['position:relative;display:flex;align-items:center;flex-shrink:0;', ';', ';'], styleProps, sizeProps);

PostfixStyled.propTypes = propTypes;
PostfixStyled.defaultProps = defaultProps;
PostfixStyled.displayName = 'PostfixStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-text-field/dist/styles/PostfixStyled.js
// module id = 846
// module chunks = 0